import { memo, useEffect, useMemo } from 'react';
import { Fade } from 'react-awesome-reveal';
import { useDispatch, useSelector } from 'react-redux';
import Banner from '../banner/Banner';
import SectionMenu from '../section-menu/SectionMenu';
import { getHCOMenuItems } from '../view/utils';
import {
  setActiveSectionTab,
  setTimespans,
} from 'store/customer/customerViewSlice';
import { getTimeSpans } from 'store/customer/customer-view-actions';
import { useQuery } from '@tanstack/react-query';
import { QUERY_KEY } from 'constants/constants';

const HealthSystem = memo((props) => {
  const { roleId } = useSelector((state) => state?.Auth?.userClaimObject);

  const selectedCustomer = useSelector(
    (state) => state?.CustomerView?.selectedCustomer
  );

  const { selectedView, componentAccessList } = props;

  const sectionMenuItems = useMemo(
    () => getHCOMenuItems(selectedView, componentAccessList, roleId),
    [selectedView, componentAccessList, roleId]
  );

  const dispatch = useDispatch();

  // React Query to fetch timespans for hco customer view
  const { data: timespans } = useQuery({
    queryKey: [QUERY_KEY.HCOTimePeriod],
    queryFn: () => getTimeSpans(),
  });

  // Set timespans in Redux Store
  useEffect(() => {
    if (timespans) {
      dispatch(setTimespans(timespans));
    }
  }, [timespans]);

  const filteredMenuItems = sectionMenuItems
    .filter((section) => section.shouldRender)
    .map(({ shouldRender, ...rest }) => rest);

  useEffect(() => {
    dispatch(setActiveSectionTab(filteredMenuItems[0]?.key));
  }, [selectedCustomer?.value]);

  return (
    <>
      <Fade>
        <Banner data={selectedView} />
      </Fade>

      <SectionMenu
        data={selectedView}
        role={roleId}
        menuItems={filteredMenuItems}
      />
    </>
  );
});

export default HealthSystem;
